module.exports = __webpack_public_path__ + "img/115.d41b375d.jpg";